import React from "react";

import "./Navbar.scss";

const Navbar = () => {
  return (
    <header className="navbar">
      <div className="logo">
        <span>Swapnil</span> <span>Shah</span>{" "}
      </div>
      <nav>
        <ul>
          <li>
            <a href="Swapnil Shah Resume.pdf" download>Resume</a>
          </li>
          <li>Blogs (Coming Soon)</li>
        </ul>
      </nav>
    </header>
  );
};

export default Navbar;
